import { supabase } from '../lib/supabase';
import type { SolarDesign, FinancialData } from '../types';
import type { BOQSummary } from './boqCalculationService';
import type { CalculationResults, CalculationInputs } from './solarCalculationEngine';
import type { PricingFactors } from './equipmentSelectionService';

export interface SavePvDesignPayload {
  design: SolarDesign;
  financials: FinancialData;
  boq: BOQSummary;
  calculationResults?: CalculationResults | null;
  calculationInputs?: CalculationInputs | null;
  pricingFactors?: PricingFactors | null;
  moduleSnapshot?: Record<string, unknown> | null;
  inverterSnapshot?: Record<string, unknown> | null;
}

function toJsonSafe(value: unknown): unknown {
  return JSON.parse(JSON.stringify(value));
}

export async function savePvDesign(projectId: string, payload: SavePvDesignPayload): Promise<string | null> {
  const body = {
    design: toJsonSafe(payload.design),
    financials: toJsonSafe(payload.financials),
    boq: toJsonSafe(payload.boq),
    calculationResults: payload.calculationResults != null ? toJsonSafe(payload.calculationResults) : null,
    calculationInputs: payload.calculationInputs != null ? toJsonSafe(payload.calculationInputs) : null,
    pricingFactors: payload.pricingFactors != null ? toJsonSafe(payload.pricingFactors) : null,
    moduleSnapshot: payload.moduleSnapshot != null ? toJsonSafe(payload.moduleSnapshot) : null,
    inverterSnapshot: payload.inverterSnapshot != null ? toJsonSafe(payload.inverterSnapshot) : null,
  };

  const { data, error } = await supabase.rpc('save_pv_design', {
    p_project_id: projectId,
    p_payload: body,
  });

  if (error) {
    console.error('save_pv_design RPC failed:', error);
    return null;
  }
  if (typeof data === 'string') return data;
  return null;
}
